import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LinkStatusService {
	readonly url: string = 'FunctionAppStatus';

	constructor(private http: HttpClient) {}

	public isLinkRunning(linkId: number): Observable<boolean> {
		return this.http.get<boolean>(this.url + '/' + 'IsLinkRunning' + '/' + linkId);
	}

	public areLinksRunning(linkIds: number[]): Observable<IsLinkRunningObject[]> {
		return this.http.post<IsLinkRunningObject[]>(this.url + '/' + 'AreLinksRunning', linkIds);
	}
}

export class IsLinkRunningObject {
	isLinkRunning: boolean;
	linkId: number;
}
